module.exports = __webpack_public_path__ + "img/icon-21.09d91ceb.png";